export default {
  // Control Tower Panel
  title: 'Wo AI Control Tower Panel',
  switchToLight: 'Switch to Light Theme',
  switchToDark: 'Switch to Dark Theme',
  systemStatus: 'Order Flow Normal',

  // Time Range Selection
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  custom: 'Custom',

  // Data Scope Selection
  myself: 'Myself',
  myDept: 'Department',
  myCompany: 'Company',
  myTenant: 'Tenant',

  // Order Source
  priceQuery: 'Price Query',
  inquiry: 'Inquiry',
  quotation: 'Quotation',
  booking: 'Booking',
  apiSyncCargoWare: 'API Sync CargoWare',

  // Data Overview
  totalOrders: 'Total Orders',
  ordersInTransit: 'Orders in Transit',
  pendingTasks: 'Pending Tasks',
  overdueTasks: 'Overdue Tasks',
  anomalyOrders: 'Anomaly Alert Orders',
  viewDetails: 'View Details',

  // Real-time Data
  realtimeOrders: 'Real-time Orders',
  realtimeTasks: 'Real-time Tasks',
  noRealtimeOrders: 'No real-time orders',
  noRealtimeTasks: 'No real-time tasks',
  globalOrderFlow: 'Global Order Flow',

  // Charts
  customsAnomalyStats: 'Customs Anomaly Order Statistics',
  inquiryDealTrend: 'Inquiry Deal Trend',
  hotInquiryRanking: 'Hot Inquiry Ranking TOP10',
  salesQuoteEfficiencyRanking: 'Sales Quote Efficiency Ranking TOP10',
  customerOrdersRanking: 'Customer Orders Ranking TOP10',

  // Task Related
  taskDetails: 'Task Details',
  viewTaskDetails: 'View Task Details',
  viewOrderDetails: 'View Order Details',
  pendingTasksList: 'Pending Tasks List',
  overdueTasksList: 'Overdue Tasks List',
  deadline: 'Deadline',
  overdueTime: 'Overdue Time',
  totalTasks: 'Total {count} tasks',
  totalOverdueHours: 'Total overdue time: {hours} hours',
  loading: 'Loading...',
  noMoreData: 'No more data',

  // Custom Date Range
  selectCustomDateRange: 'Select Custom Date Range',
  startDate: 'Start Date',
  endDate: 'End Date',
  dateRangeNote: 'Note: Date range cannot exceed 1 year',
  dateRangeExceedsOneYear: 'Date range cannot exceed 1 year',
  pleaseSelectValidDateRange: 'Please select a valid date range',

  // Error Messages
  loadInquiryDealTrendError: 'Failed to load inquiry deal trend data',
  loadPlatformIndicesError: 'Failed to load platform indices data',
  loadTaskListError: 'Failed to load task list',
  taskNotFound: 'Task not found',
  loadTaskDetailsError: 'Failed to load task details',

  // Status Messages
  loadingData: 'Loading...',
  noPermission: 'No permission',
  dataLoadFailed: 'Data load failed',
  noData: 'No data',
  selectDataRange: 'Select data range',

  // Priority
  priorityHigh: 'High',
  priorityMedium: 'Medium',
  priorityLow: 'Low',

  // Time Units
  hours: 'hours',
  days: 'days',
  orders: 'orders',

  // Button Text
  collapseDetails: 'Collapse Details',
  expandDetails: 'Expand Details',

  // Chart Units and Labels
  quantity: 'Quantity',
  inquiryQuantity: 'Inquiry Quantity',
  dealQuantity: 'Deal Quantity',
  inquiryTimes: 'Inquiries',
  average: 'Avg',
  orderCount: 'Orders'
}
